import React from "react";
import { motion } from "framer-motion";
import "./Education.css";

const Education = () => {
  return (
    <section id="education">
      <motion.div
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="eyebrow">01 — Education</span>
        <h2 className="display">
          Where the foundation <em>was laid.</em>
        </h2>
      </motion.div>

      <motion.article
        className="edu-card"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="edu-meta">
          <span className="edu-dates">2020 — 2024</span>
          <span className="edu-divider" />
          <span className="edu-location">Fullerton, CA</span>
        </div>

        <h3 className="edu-degree">B.S. Computer Science</h3>
        <p className="edu-school">California State University, Fullerton</p>

        <div className="edu-detail-row">
          <span className="edu-label">Honors</span>
          <span className="edu-value">
            Dean's List, 2023 and 2024 · Engineering Social Justice: A Design
            Challenge — Top-10 Finalist
          </span>
        </div>

        <div className="edu-detail-row">
          <span className="edu-label">Coursework</span>
          <span className="edu-value">
            Data Structures and Algorithms · Algorithm Engineering ·
            Operating System Concepts · Computer Communications · Software
            Engineering · Object-Oriented Programming · File Structure &amp;
            Database · Web Back-End Engineering · Web Front-End Engineering ·
            Artificial Intelligence · Compilers and Languages · Cybersecurity
            Foundations and Practices · Computer Organization &amp; Assembly
            Language · Principles of Computer Graphics · Computational
            Bioinformatics · Python Programming · Computer Science Principles
            · Intro to Programming
          </span>
        </div>

        <div className="edu-detail-row">
          <span className="edu-label">Certifications</span>
          <span className="edu-value">
            AWS Certified Cloud Practitioner
          </span>
        </div>

        <div className="edu-detail-row">
          <span className="edu-label">Graduated</span>
          <span className="edu-value">May 2024</span>
        </div>
      </motion.article>
    </section>
  );
};

export default Education;
